<template>
  <div class="role-chip">
    <v-tooltip top v-if="role.name">
      <template v-slot:activator="{ on }">
        <v-chip v-on="on" color="secondary" label>{{ role.name }}</v-chip>
      </template>
      <span>{{ role.description }}</span>
    </v-tooltip>
    <span v-else class="grey--text">Nenhuma</span>
  </div>
</template>

<script>
export default {
  name: "role-chip",
  props: {
    role: Object
  }
};
</script>